import { apiRequest } from '@/utils/api-request';

export interface ChatSession {
  session_id: string;
  workflow_id: string;
  node_id: string;
  chat_socket_url: string;
  session_socket_url: string;
}

export interface CreateChatSessionParams {
  sessionId: string;
  workflowId: string;
  nodeId: string;
}

export const createChatSession = async ({
  sessionId,
  workflowId,
  nodeId,
}: CreateChatSessionParams) => {
  const response = await apiRequest<ChatSession>({
    url: '/session/create-chat-session',
    method: 'POST',
    target: 'workflow',
    body: {
      session_id: sessionId,
      workflow_id: workflowId,
      node_id: nodeId,
    },
  });
  return response.data;
};
